import { Modal } from "antd";
import { CodeSnippet } from "../generic/codeSnippet/codeSnippet";
import { ExternalLink } from "../../newcomponents/table/components/ExternalLink";

interface Props {
  command: string;
  onClose?: () => void;
}

export const TerraformImportModal: React.FC<Props> = ({ command, onClose }) => {
  return (
    <Modal
      title={<div className="mr-4 text-lg">Terraform Import Commands for GVC Items</div>}
      width={900}
      open={true}
      onCancel={onClose}
      maskClosable={false}
      destroyOnHidden
      footer={null}
    >
      <div>
        <span>
          To prevent Terraform from attempting to create the resources you exported, run the following import command in
          your Terraform project. Learn more about the{" "}
        </span>
        <ExternalLink
          label={`Terraform Import Command`}
          url={`https://developer.hashicorp.com/terraform/cli/commands/import`}
          disableCopy
        />
        <span> and how it works with your state.</span>
      </div>
      <CodeSnippet className="mt-4" code={command} />
    </Modal>
  );
};
